/* card/sagas*/
import {
  all,
  put,
  takeEvery,
  spawn,
} from "redux-saga/effects";
import { isEmpty } from "ramda";
import { TerminalBackgroundTypes } from "./types";
import { remove, fetch, save } from "../../repo/terminalBackground";
import {
  fetchRequest,
  fetchError, fetchSuccess,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest
} from "./actions";
import { dirty } from "../session/actions";
import { isAuthError } from "../";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const res = yield fetch(action.payload.id, action.payload.params);
    if (res.errors && !isEmpty(res.errors)) {
      if (isAuthError(res.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(res.errors)));
    } else {
      if (action.payload.callback) {
        action.payload.callback(res.data, res.meta);
      }
      if (!action.payload.id) {
        yield put(fetchSuccess(res.data));
      }
    }
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(TerminalBackgroundTypes.FETCH, handleFetch);
}

function* handleSave(action: ReturnType<typeof saveRequest>) {
  try {
    const data = yield save(action.payload.data);
    // we may still have an error
    // if so then we should yield error
    if (data.errors && !isEmpty(data.errors)) {
      if (isAuthError(data.errors)) {
        yield put(dirty());
      }
      yield put(saveError(JSON.stringify(data.errors)));
      action.payload.callback &&
      action.payload.callback(JSON.stringify(data.errors), null);
    } else {
      yield put(saveSuccess(data));
      action.payload.callback && action.payload.callback(null, data);
    }
  } catch (err) {
    yield put(saveError(err));
    action.payload.callback &&
    action.payload.callback("An error occurred while saving background", null);
  }
}

function* handleDelete(action: ReturnType<typeof deleteRequest>) {
  try {
    const data = yield remove(action.payload.id);
    if (data.errors && !isEmpty(data.errors)) {
      if (isAuthError(data.errors)) {
        yield put(dirty());
      }
      yield put(saveError(JSON.stringify(data.errors)));
      action.payload.callback &&
      action.payload.callback(JSON.stringify(data.errors), null);
    } else {
      action.payload.callback && action.payload.callback(null, data);
    }
  } catch (err) {
    yield put(saveError(err));
    action.payload.callback &&
    action.payload.callback("An error occurred while saving background", null);
  }
}

function* watchSaveRequest() {
  yield takeEvery(TerminalBackgroundTypes.SAVE_REQUEST, handleSave);
}

function* watchDeleteRequest() {
  yield takeEvery(TerminalBackgroundTypes.DELETE_REQUEST, handleDelete);
}

export default function* cardTypeSaga() {
  yield all([
    spawn(watchFetchRequest),
    spawn(watchSaveRequest),
    spawn(watchDeleteRequest),
  ]);
}